/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ResponsePath
 */
export interface ResponsePath {
  /**
   *
   * @type {number}
   * @memberof ResponsePath
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof ResponsePath
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof ResponsePath
   */
  path: string;
}

/**
 * Check if a given object implements the ResponsePath interface.
 */
export function instanceOfResponsePath(value: object): value is ResponsePath {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('path' in value) || value['path'] === undefined) return false;
  return true;
}

export function ResponsePathFromJSON(json: any): ResponsePath {
  return ResponsePathFromJSONTyped(json, false);
}

export function ResponsePathFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePath {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    path: json['path'],
  };
}

export function ResponsePathToJSON(value?: Omit<ResponsePath, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    path: value['path'],
  };
}
